import React, {Component} from 'react';
import classNames from 'classnames';
import {default as TextInput} from '@sinclair-digital/sbg-storyline-components/src/components/forms/TextInput';
import {default as Field} from '@sinclair-digital/sbg-storyline-components/src/components/Field';
import {func, shape} from 'prop-types';
import styles from './ThemeSettings.scss';
import {themeSettingsShape} from './Theme';

class ThemeSettings extends Component {
    static propTypes = {
        onChange: func.isRequired,
        onValidatedInputChange: func.isRequired,
        themeSettings: shape(themeSettingsShape).isRequired,
    };

    render() {
        const {
            headerLogoImageUrl,
            footerLogoImageUrl,
            faviconImageUrl,
            brandColorOne,
            textColorOne,
            brandColorTwo,
            textColorTwo,
            backgroundColorOne,
            galleryLogoImageUrl,
            textColorThree,
            backgroundColorTwo,
            textColorFour,
        } = this.props.themeSettings;

        return (
            <div className={styles.ThemeSettings}>
                <h3 className={styles.psH3}>Images</h3>
                <div className={styles.row}>
                    <div className={styles.columnLeft}>
                        {/* HEADER LOGO  */}
                        <Field label="Header Logo URL">
                            <TextInput
                                className="sda-input-text-full"
                                name="headerLogoImageUrl"
                                maxLength="1024"
                                onChange={this.props.onChange}
                                placeholder="Header Logo URL"
                                type="text"
                                value={headerLogoImageUrl}
                            />
                        </Field>

                        {/* GALLERY LOGO  */}
                        <Field label="Gallery Logo URL">
                            <TextInput
                                className="sda-input-text-full"
                                name="galleryLogoImageUrl"
                                onChange={this.props.onChange}
                                maxLength="1024"
                                placeholder="Gallery Logo URL"
                                type="text"
                                value={galleryLogoImageUrl}
                            />
                        </Field>
                    </div>

                    <div className={styles.columnRight}>
                        {/* FOOTER LOGO  */}
                        <Field label="Footer Logo URL">
                            <TextInput
                                className="sda-input-text-full"
                                name="footerLogoImageUrl"
                                maxLength="1024"
                                onChange={this.props.onChange}
                                placeholder="Footer Logo URL"
                                type="text"
                                value={footerLogoImageUrl}
                            />
                        </Field>

                        {/* FAVICON  */}
                        <Field label="Favicon URL">
                            <TextInput
                                onChange={this.props.onChange}
                                name="faviconImageUrl"
                                type="text"
                                className="sda-input-text-full"
                                value={faviconImageUrl}
                                maxLength="1024"
                                placeholder="Favicon URL"
                            />
                        </Field>
                    </div>
                </div>
                <div className={styles.inputSection}>
                    <h3 className={styles.psH3}>Colors</h3>
                    <div className={styles.row}>
                        <div className={styles.columnLeft}>
                            {/* BRAND COLOR 1  */}
                            <Field label="Brand Color 1">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="brandColorOne"
                                        type="color"
                                        className={styles.colorWell}
                                        value={brandColorOne.value}
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="brandColorOne"
                                        errorMessage={brandColorOne.errorMessage}
                                        type="text"
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={brandColorOne.value}
                                        maxLength="7"
                                        placeholder="#56a1d5"
                                    />
                                </div>
                            </Field>

                            {/* BRAND COLOR 2  */}
                            <Field label="Brand Color 2">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="brandColorTwo"
                                        type="color"
                                        className={styles.colorWell}
                                        value={brandColorTwo.value}
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="brandColorTwo"
                                        type="text"
                                        errorMessage={brandColorTwo.errorMessage}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={brandColorTwo.value}
                                        maxLength="7"
                                        placeholder="#0876aa"
                                    />
                                </div>
                            </Field>

                            {/* BACKGROUND COLOR 1  */}
                            <Field label="Background Color 1">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="backgroundColorOne"
                                        type="color"
                                        className={styles.colorWell}
                                        value={backgroundColorOne.value}
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="backgroundColorOne"
                                        type="text"
                                        errorMessage={backgroundColorOne.errorMessage}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={backgroundColorOne.value}
                                        maxLength="7"
                                        placeholder="#ffffff"
                                    />
                                </div>
                            </Field>

                            {/* BACKGROUND COLOR 2  */}
                            <Field label="Background Color 2">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="backgroundColorTwo"
                                        type="color"
                                        className={styles.colorWell}
                                        onChange={this.props.onValidatedInputChange}
                                        value={backgroundColorTwo.value}
                                    />
                                    <TextInput
                                        name="backgroundColorTwo"
                                        type="text"
                                        errorMessage={backgroundColorTwo.errorMessage}
                                        onChange={this.props.onValidatedInputChange}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={backgroundColorTwo.value}
                                        maxLength="7"
                                        placeholder="#ebebeb"
                                    />
                                </div>
                            </Field>
                        </div>

                        <div className={styles.columnRight}>
                            {/* TEXT COLOR 1  */}
                            <Field label="Text Color 1">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="textColorOne"
                                        type="color"
                                        className={styles.colorWell}
                                        value={textColorOne.value}
                                        placeholder="#ffffff"
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="textColorOne"
                                        errorMessage={textColorOne.errorMessage}
                                        type="text"
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={textColorOne.value}
                                        maxLength="7"
                                        placeholder="#ffffff"
                                    />
                                </div>
                            </Field>
                            {/* TEXT COLOR 2  */}
                            <Field label="Text Color 2">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="textColorTwo"
                                        type="color"
                                        className={styles.colorWell}
                                        value={textColorTwo.value}
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="textColorTwo"
                                        type="text"
                                        errorMessage={textColorTwo.errorMessage}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={textColorTwo.value}
                                        maxLength="7"
                                        placeholder="#ffffff"
                                    />
                                </div>
                            </Field>

                            {/* TEXT COLOR 3  */}
                            <Field label="Text Color 3">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="textColorThree"
                                        type="color"
                                        className={styles.colorWell}
                                        onChange={this.props.onValidatedInputChange}
                                        value={textColorThree.value}
                                    />
                                    <TextInput
                                        name="textColorThree"
                                        type="text"
                                        errorMessage={textColorThree.errorMessage}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={textColorThree.value}
                                        maxLength="7"
                                        placeholder="#333333"
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                </div>
                            </Field>

                            {/* TEXT COLOR 4  */}
                            <Field label="Text Color 4">
                                <div className={styles.colorWrap}>
                                    <input
                                        name="textColorFour"
                                        type="color"
                                        className={styles.colorWell}
                                        value={textColorFour.value}
                                        onChange={this.props.onValidatedInputChange}
                                    />
                                    <TextInput
                                        onChange={this.props.onValidatedInputChange}
                                        name="textColorFour"
                                        type="text"
                                        errorMessage={textColorFour.errorMessage}
                                        className={classNames(styles.colorTextInput, 'sda-input-text-full')}
                                        value={textColorFour.value}
                                        maxLength="7"
                                        placeholder="#56a1d5"
                                    />
                                </div>
                            </Field>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ThemeSettings;
